module.exports = __webpack_public_path__ + "img/setting.9efda397.svg";